import { Injectable } from '@angular/core';
// import { Http, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
// import { HttpHeaders } from '@angular/common/http';
// import {Observable} from 'rxjs/Observable';
import { Router, ActivatedRoute } from "@angular/router";
declare var google: any;

import 'rxjs/Rx';
declare const $: any;
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private serviceData: any;
  public nodeApi = 'https://acealert.in/nik';//for node server api
  private serverImagePath = "https://acealert.in/nik/images";
  private serverVideoPath = "https://acealert.in/nik/videos";
  private serverDocumentPath = "https://acealert.in/nik/document";
  public transliterationControl;
  // private nodeApi = 'localhost:9000';//for node server api
  // private serverImagePath = "localhost:9000/images";
  // private serverVideoPath = "localhost:9000/videos";
  // private nodeApi = 'http://192.168.1.131:8042';//for node server api
  // private serverImagePath = "http://192.168.1.131:8042/images";
  // private serverVideoPath = "http://192.168.1.131:8042/videos";
  public OneMessageChars = '';
  CountMessageChars = 0;
  maxChars = 320;
  MessageCount = 0;
  PreviewMessage = '';
  public prefix = 'acealert_' + this.nodeApi + '_';

  public passwordRegex = '^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$';
  public numberRegex = '^[0-9]{10}$';
  public allowOnlyChar = '^[a-zA-Z]+$';
  public allowOnlyNumber = '^[0-9]';
  public passwordRegexErrorMessage = "Password must have atleast 8 character, 1 Special character, 1 Uppercase and 1 Lowercase character";
  constructor(private http: HttpClient, private router: Router,
    private route: ActivatedRoute) { }



  private extractData(res) {

    this.serviceData = res;
    if (this.serviceData.status == false) {
    }
    return this.serviceData || {};
  }

  sendRequestToNode(params) {
    // this.showLoader();
    params.url = this.nodeApi; // override node api
    var resArr;
    if (params.method && params.method == "postdata") {
      var Url = params.url + '/' + params.path;
      var body = params.queryParam;
      resArr = this.http.post(Url, body);
    }
    else if (params.method && params.method == "post") {
      resArr = this.http.post(params.url + '/' + params.path, params.postData) // define a variable server_url to assign the requested url
        .map(this.extractData);
    }
    else if (params.method && params.method == "delete") {
      resArr = this.http.delete(params.url + '/' + params.path) // define a variable server_url to assign the requested url
        .map(this.extractData);
    }
    else if (params.method && params.method == "put") {

      resArr = this.http.put(params.url + '/' + params.path, params.postData) // define a variable server_url to assign the requested url
        .map(this.extractData);
    }
    else {
      resArr = this.http.get(params.url + '/' + params.path, { params: params.queryParam }) // define a variable server_url to assign the requested url
        .map(this.extractData);

    }

    return resArr;
  }

  generatePassword() {
    var special = ['@', '!', '$', '#', '&'];
    var numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

    var length = 6,
      charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    retVal += special[Math.floor(Math.random() * special.length)];
    retVal += numbers[Math.floor(Math.random() * numbers.length)];

    return retVal;
  }

  public onLoad(Original_Message) {
    // console.log(Original_Message);
    var options = {
      sourceLanguage: 'en',
      destinationLanguage: ['hi', 'ar', 'kn', 'ml', 'ta', 'te', 'gu', 'sa'],
      transliterationEnabled: true,
      shortcutKey: 'ctrl+g'
    };
    // Create an instance on TransliterationControl with the required
    // options.
    this.transliterationControl =
      new google.elements.transliteration.TransliterationControl(options);
    // Enable transliteration in the textfields with the given ids.
    var ids = [Original_Message];
    this.transliterationControl.makeTransliteratable(ids);

    // Add the STATE_CHANGED event handler to correcly maintain the state
    // of the checkbox.
    this.transliterationControl.addEventListener(
      google.elements.transliteration.TransliterationControl.EventType.STATE_CHANGED,
      this.transliterateStateChangeHandler);

    // Set the checkbox to the correct state.
    this.transliterationControl.isTransliterationEnabled();
  }

  // Handler for STATE_CHANGED event which makes sure checkbox status
  // reflects the transliteration enabled or disabled status.
  public transliterateStateChangeHandler(e) {
    return this.transliterationControl.transliterationEnabled;
  }

  // Handler for dropdown option change event.  Calls setLanguagePair to
  // set the new language.

  languageChangeHandler(SMS_language_ID) {
    var LanguageID = SMS_language_ID;
    return this.sendRequestToNode({ method: 'get', path: 'language/getLanguageByID', queryParam: { 'LanguageID': LanguageID } });
  }

  generateUsername() {
    let retVal = Math.floor(Math.random() * 9000000) + 100000;
    var res = 'C' + retVal;
    return res;
  }

  getNodeApi() {
    return this.nodeApi;
  }

  getImagePath() {
    return this.serverImagePath;
  }
  getDocumentPath() {
    return this.serverDocumentPath;
  }
  getVideoPath() {
    return this.serverVideoPath;
  }

  hideLoader() {
    $('#loader').addClass('myloader-hide');
  }

  showLoader() {
    $('#loader').removeClass('myloader-hide');
  }
  getUserDataFromLocalStorage() {
    if (localStorage.getItem(this.prefix + 'userData') != 'undefined') {
      //console.log(JSON.parse(localStorage.getItem(this.prefix+'userData')));
      return JSON.parse(localStorage.getItem(this.prefix + 'userData'));
    }
    return null;
  }

  logOutTime() {
    this.sendRequestToNode({ method: 'get', path: 'auth/logout' }).subscribe(result => {
      return true;
    });
  }

  formatDate(date, format = "") {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    if (format == 'm-d-y') {
      return [month, year, day].join('-');
    }
    else if (format == 'd-m-y') {
      return [day, month, year].join('-');
    }
    else if (format == 'd-m') {
      return [day, month].join('-');
    }
    else if (format == 'd/m/y') {
      return [day, month, year].join('/');
    }
    else {
      return [year, month, day].join('-');
    }
  }

  public ItemsPerPage = [5, 10, 15, 20, 50, 'ALL'];
  public DefaultItemsPerPage = 10;

  deleteTitle = 'Are you sure?';
  deleteText = 'You won\'t be able to revert this!';
  confirmButtonText = 'Yes';
  sussDeleteDialogueTitle = "Deleted!";
  sussCancelledDialogueTitle = "Cancelled!";
  sussInsertDialogueTitle = "Inserted!";
  sussUpdateDialogueTitle = "Updated!";
  sussSentDialogueTitle = "Sent!";




}
